import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  JbOverlay
} from "./chunk.5C7B4R5Q.js";
import {
  EffectFade,
  Navigation,
  Pagination,
  core_default
} from "./chunk.VVD5NVY2.js";
import {
  isMobileVP,
  isTabletVP
} from "./chunk.YDQDJZUC.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  Rt
} from "./chunk.LTAMHVKK.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  debounce,
  recenterNavItems
} from "./chunk.WXNWU2SV.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-gallery/jb-gallery.scss?inline
var jb_gallery_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.swiper-pagination-fraction, .content-credit, .content-text, .content-title {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.content-title {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  .content-title {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

.content-text {
  font-size: var(--theme-typo-p-small-desktop-fontsize, 1rem);
  line-height: var(--theme-typo-p-small-desktop-lineheight, 1.625rem);
}

.content-credit {
  font-size: var(--theme-typo-p-mini-desktop-fontsize, 0.813rem);
  line-height: var(--theme-typo-p-mini-desktop-lineheight, 1.25rem);
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */
@font-face {
  font-family: "swiper-icons";
  src: url("data:application/font-woff;charset=utf-8;base64, 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") format("woff");
  font-weight: 400;
  font-style: normal;
}
:root {
  --swiper-theme-color: #007aff;
}

.swiper {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
}

.swiper-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-pointer-events {
  touch-action: pan-y;
}
.swiper-pointer-events.swiper-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

/* Auto Height */
.swiper-autoheight,
.swiper-autoheight .swiper-slide {
  height: auto;
}
.swiper-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-backface-hidden .swiper-slide {
  transform: translateZ(0);
  backface-visibility: hidden;
}

/* 3D Effects */
.swiper-3d, .swiper-3d.swiper-css-mode .swiper-wrapper {
  perspective: 1200px;
}
.swiper-3d .swiper-wrapper,
.swiper-3d .swiper-slide,
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom,
.swiper-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}
.swiper-3d .swiper-slide-shadow,
.swiper-3d .swiper-slide-shadow-left,
.swiper-3d .swiper-slide-shadow-right,
.swiper-3d .swiper-slide-shadow-top,
.swiper-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}
.swiper-3d .swiper-slide-shadow {
  background: rgba(0, 0, 0, 0.15);
}
.swiper-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(to left, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}
.swiper-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
}

/* CSS Mode */
.swiper-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none; /* For Firefox */
  -ms-overflow-style: none; /* For Internet Explorer and Edge */
}
.swiper-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}
.swiper-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-horizontal.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-vertical.swiper-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

.swiper-centered > .swiper-wrapper::before {
  content: "";
  flex-shrink: 0;
  order: 9999;
}
.swiper-centered.swiper-horizontal > .swiper-wrapper > .swiper-slide:first-child {
  margin-inline-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-horizontal > .swiper-wrapper::before {
  height: 100%;
  width: var(--swiper-centered-offset-after);
}
.swiper-centered.swiper-vertical > .swiper-wrapper > .swiper-slide:first-child {
  margin-block-start: var(--swiper-centered-offset-before);
}
.swiper-centered.swiper-vertical > .swiper-wrapper::before {
  width: 100%;
  height: var(--swiper-centered-offset-after);
}
.swiper-centered > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: center center;
  scroll-snap-stop: always;
}

:root {
  /*
  --swiper-pagination-color: var(--swiper-theme-color);
  --swiper-pagination-bullet-size: 8px;
  --swiper-pagination-bullet-width: 8px;
  --swiper-pagination-bullet-height: 8px;
  --swiper-pagination-bullet-inactive-color: #000;
  --swiper-pagination-bullet-inactive-opacity: 0.2;
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-horizontal-gap: 4px;
  --swiper-pagination-bullet-vertical-gap: 6px;
  */
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}
.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}
.swiper-pagination-disabled > .swiper-pagination, .swiper-pagination.swiper-pagination-disabled {
  display: none !important;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}
.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px));
  height: var(--swiper-pagination-bullet-height, var(--swiper-pagination-bullet-size, 8px));
  display: inline-block;
  border-radius: 50%;
  background: var(--swiper-pagination-bullet-inactive-color, #000);
  opacity: var(--swiper-pagination-bullet-inactive-opacity, 0.2);
}
button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}
.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: var(--swiper-pagination-bullet-opacity, 1);
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-vertical > .swiper-pagination-bullets,
.swiper-pagination-vertical.swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}
.swiper-vertical > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: var(--swiper-pagination-bullet-vertical-gap, 6px) 0;
  display: block;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}
.swiper-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 4px);
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.swiper-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,
.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-horizontal.swiper-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

/* Progress */
.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}
.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}
.swiper-horizontal > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal, .swiper-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}
.swiper-vertical > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-vertical, .swiper-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite, .swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-lock {
  display: none;
}

:host {
  display: block;
}

.swiper.is-loaded {
  overflow: visible;
}

jb-close-icon {
  block-size: 30px;
  cursor: pointer;
  inline-size: 30px;
  inset-block-start: 20px;
  inset-inline-end: 20px;
  position: fixed;
  z-index: 11;
}
@media (min-width: 960px) {
  jb-close-icon {
    inset-block-start: 46px;
    inset-inline-end: 65px;
  }
}

.swiper-container {
  position: relative;
}

jb-fullscreen-icon {
  block-size: 50px;
  cursor: pointer;
  display: none;
  inline-size: 50px;
  inset-block-start: 40px;
  inset-inline-end: 40px;
  position: absolute;
  z-index: 11;
}
@media (min-width: 960px) {
  jb-fullscreen-icon {
    display: block;
  }
}

.image-wrapper {
  margin-block-end: 72px;
}
@media (min-width: 960px) {
  .image-wrapper {
    margin-block-end: var(--spacing-s);
  }
}

@media (min-width: 960px) {
  .intranet .image-wrapper {
    margin-block-end: 72px;
  }
  .intranet .content {
    inline-size: calc(100% - 2 * var(--row-large-margin));
    margin-inline: var(--row-large-margin);
  }
}
@media (min-width: 1281px) {
  .intranet .image-wrapper {
    margin-block-end: var(--spacing-s);
  }
  .intranet .content {
    inline-size: calc(100% - var(--_control-wrapper-width));
    margin-inline: 0;
  }
}

jb-picture {
  background: rgba(var(--theme-color-smoke, 113 124 125)/var(--theme-opacity-10, 0.1));
}

.content {
  --_control-wrapper-width: 312px;
  inline-size: calc(100% - 2 * var(--row-small-margin));
  margin-inline: var(--row-small-margin);
  min-block-size: 35px;
}
@media (min-width: 600px) {
  .content {
    inline-size: calc(100% - 2 * var(--row-large-margin));
    margin-inline: var(--row-large-margin);
  }
}
@media (min-width: 960px) {
  .content {
    inline-size: calc(100% - var(--_control-wrapper-width));
    margin-inline: 0;
  }
}

.content-title {
  margin-block-end: var(--spacing-base);
}

.content-text {
  margin-block-end: var(--spacing-base);
}

.content-credit {
  color: rgb(var(--theme-color-royal-blue, 20 30 85)/var(--theme-opacity-70, 0.7));
}

.controls {
  align-items: center;
  display: flex;
  inline-size: max-content;
  inset-inline-end: var(--row-small-margin);
  justify-content: flex-end;
  position: absolute;
  user-select: none;
  z-index: 2;
}
@media (min-width: 600px) {
  .controls {
    inset-inline-end: 10.1%;
  }
}
@media (min-width: 960px) {
  .controls {
    inset-inline-end: 0;
  }
}

.fullscreen .swiper {
  margin: 0;
}
.fullscreen .content {
  margin-block-end: 50px;
}
.fullscreen .swiper-slide {
  inline-size: 100% !important;
}

.swiper-pagination {
  color: rgb(var(--theme-color-royal-blue, 20 30 85)/var(--theme-opacity-20, 0.2));
  margin-inline-end: 10px;
  text-align: end;
}
@media (min-width: 600px) {
  .swiper-pagination {
    line-height: 2.75rem;
  }
}
.swiper-pagination span {
  color: rgb(var(--theme-color-royal-blue, 20 30 85));
}

.swiper-pagination-fraction {
  font-size: 2.063rem;
  inset-block-end: 0;
  line-height: 2.5rem;
  position: relative;
}
.swiper-pagination-fraction .swiper-pagination-current {
  block-size: 44px;
  display: inline-block;
  inline-size: 83px;
  text-align: center;
}
.swiper-pagination-fraction .swiper-pagination-total {
  block-size: 44px;
  display: inline-block;
  inline-size: 83px;
  opacity: 0.2;
  text-align: center;
}
.swiper-pagination-fraction .swiper-pagination-separator {
  display: inline-block;
  font-size: 1.875rem;
  inset-block-start: -2px;
  line-height: 2.188rem;
  opacity: 0.2;
  position: relative;
}

.swiper-pagination-lock {
  display: block;
}

.aspect-3by2 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-3by2 > *,
.aspect-3by2 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-3by2::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(2 / 3 * 100%);
  position: relative;
  width: 100%;
}

.aspect-4by3 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-4by3 > *,
.aspect-4by3 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-4by3::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(3 / 4 * 100%);
  position: relative;
  width: 100%;
}

.aspect-16by9 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-16by9 > *,
.aspect-16by9 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-16by9::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(9 / 16 * 100%);
  position: relative;
  width: 100%;
}

.aspect-21by9 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-21by9 > *,
.aspect-21by9 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-21by9::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(9 / 21 * 100%);
  position: relative;
  width: 100%;
}

.aspect-2by3 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-2by3 > *,
.aspect-2by3 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-2by3::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(1 / 1 * 100%);
  position: relative;
  width: 100%;
}

.aspect-3by4 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-3by4 > *,
.aspect-3by4 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-3by4::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(1 / 1 * 100%);
  position: relative;
  width: 100%;
}

.aspect-9by16 {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.aspect-9by16 > *,
.aspect-9by16 iframe {
  height: 100%;
  inset: 0;
  position: absolute;
  width: 100%;
}
.aspect-9by16::before {
  content: "";
  display: block;
  height: 0;
  padding-bottom: calc(1 / 1 * 100%);
  position: relative;
  width: 100%;
}`;

// src/components/jb-gallery/jb-gallery.ts
core_default.use([Navigation, Pagination, EffectFade]);
var JbGallery = class extends Spaceable(h) {
  constructor() {
    super(...arguments);
    this.aspect = "16by9";
    this.initialSlide = 0;
    this.isFullscreen = false;
    this._isLoaded = false;
    this._options = {
      contentWrappers: null,
      controlWrap: null,
      defaultScreen: null,
      fullScreen: null,
      images: null,
      imageWrappers: null,
      openButton: null,
      picturesCount: 0,
      picturesLoadedCount: 0,
      slider: null,
      swiper: null
    };
  }
  firstUpdated() {
    this._init();
  }
  _bindEvents() {
    this._options.openButton?.addEventListener("click", async (e) => {
      e.preventDefault();
      const galleryFullscreen = new JbGalleryFullscreen().init({
        props: {
          gallery: this,
          currentSlide: this._options.swiper?.activeIndex,
          withSpacing: true
        }
      });
      galleryFullscreen.addEventListener("jb-gallery:slide-changed", (ev) => {
        this._options.swiper?.slideTo(ev.detail.currentSlide);
      });
      await customElements.whenDefined("jb-gallery-fullscreen").then(async () => {
        setTimeout(() => {
          galleryFullscreen.contentChildren = [galleryFullscreen.shadowRoot.querySelector("div")];
        }, 0);
      });
      const overlay = new JbOverlay().init({
        props: { color: "white", hasLogo: false, fullHeight: true },
        childNodes: [galleryFullscreen]
      });
      overlay.addEventListener("jb-gallery-fullscreen:resized-too-small", async () => {
        await galleryFullscreen.hide();
        overlay.unstack();
        enableBodyScroll(this);
        recenterNavItems();
      });
      document.addEventListener("jb-overlay:close", async () => {
        await galleryFullscreen.hide();
        overlay.unstack();
        enableBodyScroll(this);
        recenterNavItems();
      });
      overlay.stack();
      disableBodyScroll(this, { allowTouchMove: () => true });
      recenterNavItems();
      await galleryFullscreen.reveal();
    });
    if (this._options.controlWrap !== null) {
      this._setControlWrapPosition();
      window.addEventListener(
        "resize",
        debounce(() => {
          this._handleResize();
        }, 100)
      );
    }
  }
  _dom() {
    this._options.controlWrap = this.renderRoot.querySelector(".controls");
    this._options.imageWrappers = this.renderRoot.querySelectorAll(".image-wrapper");
    this._options.contentWrappers = this.renderRoot.querySelectorAll(".content");
    this._options.openButton = this.renderRoot.querySelector("jb-fullscreen-icon");
    this._options.defaultScreen = this.renderRoot.querySelector(".default-screen-placeholder");
    this._options.images = this.renderRoot.querySelectorAll("jb-picture");
    const swiperOptions = {
      initialSlide: this.initialSlide,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 40,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      on: {
        slideChange: (swiper) => {
          this.dispatchEvent(
            new CustomEvent("jb-gallery:slide-changed", {
              bubbles: true,
              composed: true,
              detail: {
                currentSlide: swiper.activeIndex
              }
            })
          );
        },
        init: () => {
          this._isLoaded = true;
        }
      },
      pagination: {
        el: this.renderRoot.querySelector(".swiper-pagination"),
        type: "fraction",
        // @ts-ignore: Type expected number as return value
        formatFractionTotal: (num) => ("0" + num).slice(-2),
        // @ts-ignore: Type expected number as return value
        formatFractionCurrent: (num) => ("0" + num).slice(-2),
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span><span class="swiper-pagination-separator">/</span><span class="${totalClass}"></span>`;
        }
      },
      navigation: {
        nextEl: this.renderRoot.querySelector("jb-arrow-navigation")?.shadowRoot?.querySelector("jb-arrow-icon:nth-of-type(2)")?.shadowRoot?.firstElementChild,
        prevEl: this.renderRoot.querySelector("jb-arrow-navigation")?.shadowRoot?.querySelector("jb-arrow-icon:nth-of-type(1)")?.shadowRoot?.firstElementChild
      }
    };
    this._options.slider = this.renderRoot.querySelector(".swiper-container");
    this._options.swiper = new core_default(this._options.slider, swiperOptions);
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 9, type: "media", horizontal: "full-width-sm-down", grid: "legacy" };
  }
  _handleResize() {
    this._setControlWrapPosition();
  }
  _init() {
    const pictures = this.renderRoot.querySelectorAll("jb-picture");
    this._options.picturesCount = pictures.length;
    pictures.forEach(() => {
      this._options.picturesLoadedCount += 1;
    });
    const picturesInterval = setInterval(() => {
      if (this._options.picturesCount <= this._options.picturesLoadedCount) {
        clearInterval(picturesInterval);
        this._dom();
        this._bindEvents();
      }
    }, 100);
  }
  _renderImages() {
    return this.images.map(
      (img) => ke`
        <div class="slide swiper-slide">
          <div class="image-wrapper aspect-${this.aspect}">
            <jb-picture
              .alt=${img.picture.alt}
              .imgData=${img.picture.imgData}
              .lazy=${img.picture.lazy}
              .fit=${"contain"}
            ></jb-picture>
          </div>
          <div class="content">
            <h5 class="content-title">${img.caption}</h5>
            <p class="content-text">${img.text}</p>
            <span class="content-credit">${img.credit}</span>
          </div>
        </div>
      `
    );
  }
  _setControlWrapPosition() {
    if (this._options.controlWrap && this._options.imageWrappers) {
      this._options.controlWrap.style.setProperty("top", this._options.imageWrappers[0].offsetHeight + 16 + "px");
    }
  }
  render() {
    return this.images?.length ? ke`
          <div class=${Rt({ gallery: true, fullscreen: !!this.isFullscreen, intranet: !!this.intranetStyle })}>
            <div class="swiper ${Rt({ "is-loaded": this._isLoaded })}">
              <div class="swiper-container">
                ${!this.isFullscreen ? ke`<jb-fullscreen-icon></jb-fullscreen-icon>` : D}
                <div class="swiper-wrapper">${this._renderImages()}</div>
                <div class="controls">
                  <div class="swiper-pagination pagination"></div>
                  <jb-arrow-navigation></jb-arrow-navigation>
                </div>
              </div>
            </div>
          </div>
        ` : D;
  }
};
JbGallery.styles = r(jb_gallery_default);
__decorateClass([
  n()
], JbGallery.prototype, "aspect", 2);
__decorateClass([
  n({ type: Array })
], JbGallery.prototype, "images", 2);
__decorateClass([
  n({ type: Number })
], JbGallery.prototype, "initialSlide", 2);
__decorateClass([
  n({ type: Boolean })
], JbGallery.prototype, "intranetStyle", 2);
__decorateClass([
  n({ type: Boolean })
], JbGallery.prototype, "isFullscreen", 2);
__decorateClass([
  r2()
], JbGallery.prototype, "_isLoaded", 2);
JbGallery = __decorateClass([
  customElement("jb-gallery")
], JbGallery);

// src/components/jb-gallery-fullscreen/jb-gallery-fullscreen.scss?inline
var jb_gallery_fullscreen_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  width: 100%;
}
:host > div {
  opacity: 0;
}

div {
  height: 100%;
}

.aspect-3by2 {
  margin-inline: 16%;
}

.aspect-4by3 {
  margin-inline: 20%;
}

.aspect-16by9 {
  margin-inline: 10%;
}

.aspect-21by9 {
  margin-inline: 10%;
}

.aspect-2by3,
.aspect-3by4,
.aspect-9by16 {
  margin-inline: 28%;
}`;

// src/components/jb-gallery-fullscreen/jb-gallery-fullscreen.ts
var JbGalleryFullscreen = class extends Initiable(Animatable(h)) {
  constructor() {
    super(...arguments);
    this.currentSlide = 0;
  }
  firstUpdated() {
    window.addEventListener(
      "resize",
      debounce(() => {
        this._handleResize();
      }, 100)
    );
    document.addEventListener("jb-gallery:slide-changed", (e) => {
      this.currentSlide = e.detail.currentSlide;
    });
  }
  _handleResize() {
    if (isMobileVP() || isTabletVP()) {
      this._resizedTooSmall();
    }
  }
  _resizedTooSmall() {
    this.dispatchEvent(
      new CustomEvent("jb-gallery-fullscreen:resized-too-small", {
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <div
        class=${Rt({
      [`aspect-${this.gallery.aspect}`]: true
    })}
      >
        <jb-gallery
          .aspect=${this.gallery.aspect}
          .images=${this.gallery.images}
          .initialSlide=${this.currentSlide}
          isFullscreen
          .fit=${"contain"}
        ></jb-gallery>
      </div>
    `;
  }
};
JbGalleryFullscreen.styles = r(jb_gallery_fullscreen_default);
__decorateClass([
  n({ type: Number })
], JbGalleryFullscreen.prototype, "currentSlide", 2);
__decorateClass([
  n({ type: Object })
], JbGalleryFullscreen.prototype, "gallery", 2);
JbGalleryFullscreen = __decorateClass([
  customElement("jb-gallery-fullscreen")
], JbGalleryFullscreen);

export {
  JbGalleryFullscreen,
  JbGallery
};
